import { PageLayout } from '../components/PageLayout'

export function TermosDeUso() {
  return (
    <PageLayout title="Termos de Uso" lastUpdated="17 de Janeiro de 2025">
      <section>
        <h2>1. Aceitação dos Termos</h2>
        <p>
          Ao acessar e utilizar a plataforma SecBrain Neurodivergente ("Plataforma"), você concorda com estes
          Termos de Uso. Se você não concordar com qualquer parte destes termos, não deverá utilizar nossos serviços.
        </p>
        <p>
          A Plataforma é operada por Secbrain Inteligencia Artificial Tecnologia LTDA, inscrita no CNPJ sob o
          nº 52.234.008/0001-16, com sede na Avenida Júlia Freire, 1200, Sala 109/110/111/112, Expedicionários, João Pessoa - PB, CEP 58041-000 ("SecBrain", "nós" ou "nossos").
        </p>
      </section>

      <section>
        <h2>2. Descrição do Serviço</h2>
        <p>
          O SecBrain Neurodivergente é uma plataforma de tecnologia que auxilia profissionais de saúde no
          acompanhamento de pacientes neurodivergentes. O serviço inclui:
        </p>
        <ul>
          <li>Recebimento e processamento de relatórios enviados por familiares via WhatsApp</li>
          <li>Organização e categorização automática de informações clínicas</li>
          <li>Geração de resumos e alertas para profissionais de saúde</li>
          <li>Armazenamento seguro de histórico de acompanhamento</li>
        </ul>
        <p>
          <strong>Importante:</strong> A Plataforma é uma ferramenta de apoio e organização de informações.
          Ela não substitui a avaliação, diagnóstico ou tratamento realizado por profissionais de saúde qualificados.
        </p>
      </section>

      <section>
        <h2>3. Elegibilidade e Cadastro</h2>
        <p>
          Para utilizar a Plataforma, você deve:
        </p>
        <ul>
          <li>Ser profissional de saúde devidamente registrado em seu conselho de classe (CRM, CRP, etc.)</li>
          <li>Ter pelo menos 18 anos de idade</li>
          <li>Fornecer informações verdadeiras, precisas e completas durante o cadastro</li>
          <li>Manter suas credenciais de acesso em sigilo</li>
        </ul>
        <p>
          Você é responsável por todas as atividades realizadas em sua conta. Notifique-nos imediatamente
          caso suspeite de uso não autorizado.
        </p>
      </section>

      <section>
        <h2>4. Uso Adequado da Plataforma</h2>
        <p>
          Ao utilizar nossos serviços, você concorda em:
        </p>
        <ul>
          <li>Utilizar a Plataforma apenas para fins profissionais legítimos de acompanhamento de pacientes</li>
          <li>Obter o consentimento adequado dos pacientes e/ou responsáveis legais antes de cadastrá-los</li>
          <li>Não compartilhar suas credenciais de acesso com terceiros</li>
          <li>Não utilizar a Plataforma para fins ilegais ou não autorizados</li>
          <li>Não tentar acessar dados de outros usuários ou organizações</li>
          <li>Não realizar engenharia reversa ou tentativas de comprometer a segurança do sistema</li>
        </ul>
      </section>

      <section>
        <h2>5. Dados e Privacidade</h2>
        <p>
          A coleta, uso e proteção de dados pessoais são regidos por nossa{' '}
          <a href="/privacidade">Política de Privacidade</a> e{' '}
          <a href="/lgpd">Política LGPD</a>, que fazem parte integrante destes Termos.
        </p>
        <p>
          Você reconhece que, como profissional de saúde, é corresponsável pela proteção dos dados de
          seus pacientes e deve garantir que possui base legal adequada para o tratamento dessas informações.
        </p>
      </section>

      <section>
        <h2>6. Propriedade Intelectual</h2>
        <p>
          A Plataforma, incluindo seu código, design, marcas, conteúdos e funcionalidades, é propriedade
          exclusiva do SecBrain ou de seus licenciadores. Você não adquire nenhum direito de propriedade
          sobre esses elementos ao utilizar o serviço.
        </p>
        <p>
          Os dados clínicos inseridos por você permanecem de sua propriedade e de seus pacientes,
          conforme aplicável.
        </p>
      </section>

      <section>
        <h2>7. Disponibilidade e Suporte</h2>
        <p>
          Empenhamo-nos em manter a Plataforma disponível 24 horas por dia, 7 dias por semana.
          No entanto, não garantimos disponibilidade ininterrupta, podendo haver períodos de
          manutenção programada ou não programada.
        </p>
        <p>
          O suporte técnico está disponível através dos canais indicados na Plataforma, em horário comercial.
        </p>
      </section>

      <section>
        <h2>8. Planos e Pagamentos</h2>
        <p>
          Os valores, condições de pagamento e funcionalidades de cada plano estão descritos em
          nossa página de preços. Ao contratar um plano pago, você concorda com:
        </p>
        <ul>
          <li>Pagamento recorrente na periodicidade escolhida (mensal ou anual)</li>
          <li>Renovação automática ao final de cada período, salvo cancelamento prévio</li>
          <li>Possibilidade de alteração de preços mediante aviso prévio de 30 dias</li>
        </ul>
      </section>

      <section>
        <h2>9. Cancelamento</h2>
        <p>
          Você pode cancelar sua assinatura a qualquer momento através do painel de controle ou
          entrando em contato com nosso suporte. O cancelamento será efetivado ao final do período
          já pago, sem direito a reembolso proporcional.
        </p>
        <p>
          Após o cancelamento, seus dados permanecerão disponíveis para exportação por 30 dias,
          após os quais serão excluídos conforme nossa política de retenção.
        </p>
      </section>

      <section>
        <h2>10. Limitação de Responsabilidade</h2>
        <p>
          O SecBrain fornece a Plataforma "como está" e não se responsabiliza por:
        </p>
        <ul>
          <li>Decisões clínicas tomadas com base nas informações organizadas pela Plataforma</li>
          <li>Danos indiretos, incidentais ou consequenciais decorrentes do uso do serviço</li>
          <li>Interrupções temporárias no serviço</li>
          <li>Ações de terceiros, incluindo familiares de pacientes</li>
        </ul>
        <p>
          Nossa responsabilidade total está limitada ao valor pago por você nos últimos 12 meses.
        </p>
      </section>

      <section>
        <h2>11. Alterações nos Termos</h2>
        <p>
          Podemos atualizar estes Termos periodicamente. Alterações significativas serão comunicadas
          por e-mail ou através da Plataforma com antecedência mínima de 15 dias. O uso continuado
          após as alterações constitui aceitação dos novos termos.
        </p>
      </section>

      <section>
        <h2>12. Legislação Aplicável e Foro</h2>
        <p>
          Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o
          foro da Comarca de João Pessoa, PB, para dirimir quaisquer controvérsias, com renúncia
          a qualquer outro, por mais privilegiado que seja.
        </p>
      </section>

      <section>
        <h2>13. Contato</h2>
        <p>
          Para dúvidas sobre estes Termos de Uso, entre em contato:
        </p>
        <ul>
          <li>E-mail: <a href="mailto:info@secbra.in">info@secbra.in</a></li>
          <li>Endereço: Avenida Júlia Freire, 1200, Sala 109/110/111/112, Expedicionários, João Pessoa - PB, CEP 58041-000</li>
        </ul>
      </section>
    </PageLayout>
  )
}
